// todo use google library: https://github.com/mild-blue/online-connect/issues/65
import { PhoneNumberDto } from '../../generated';
import parsePhoneNumber from 'libphonenumber-js';

export const fromPhoneToGenerated = (data: string): PhoneNumberDto => {
  const phoneNumber = parsePhoneNumber(data);

  if (!phoneNumber) {
    console.error('Telefónní číslo není validní.');
  }

  return {
    number: phoneNumber?.number.toString() || '',
    countryCode: phoneNumber?.country || ''
  };
};
